import {
  forwardRef,
  SetStateAction,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react"; // NOSONAR : ignore
import DynamicReport from "../DynamicReport/DynamicReport";
import InterfaceComponent from "../../Pages/Masters/InterfaceComponent";
import {
  ActionHandlerProvider,
  useActionHandler,
} from "../ActionHandlerContext";

const DynamicMaster = forwardRef(({ ...props }, ref) => {
  const [type, setType] = useState<string>("");
  const [formRId, setFormRId] = useState<number>(0);
  const [hideBtn, setHideBtn] = useState<boolean>(true);
  const [mode, setMode] = useState("");

  const dashboardRef = useRef();
  const formRef = useRef();

  useEffect(() => {
    console.log("DynamicMaster props", props);

    if (props?.DashboardName == null) {
      // console.log('DynamicMaster if block', props);

      setHideBtn(false);
    }
  }, []);

  useImperativeHandle(ref, () => ({
    reloadDashboard: () => {
      dashboardRef?.current?.reloadDashboard();
    },
    hideFields: (fieldName: any) => {
      formRef?.current?.hideFields(fieldName);
    },
    showFields: (fieldName: any) => {
      formRef?.current?.showFields(fieldName);
    },
    setValue: (fieldName: any, value: any) => {
      formRef?.current?.setValue(fieldName, value);
    },
    disableField: (fieldName: any) => {
      formRef?.current?.disableField(fieldName);
    },
    enableField: (fieldName: any) => {
      formRef?.current?.enableField(fieldName);
    },
    setMaskedValue: (fieldName: any, value: any) => {
      formRef?.current?.setMaskedValue(fieldName, value);
    },
    setFieldVisibility: (updates: { fieldName: string; updates: any }[]) => {
      formRef?.current?.setFieldVisibility(updates);
    },
  }));

  const handleCancel = () => {
    // props?.resetMaskedState(true);
    setHideBtn(true);
  };

  const {
    rowActionHandler,
    reportActionHandler,
    interfaceActionHandler,
    interfaceFieldActionHandler,
    autoSearchActionHandler,
  } = useActionHandler();
  const childRowHandlers = {
    ...rowActionHandler, // Merge Parent's rowActionHandler
    DynamicMasterRowEdit:
      rowActionHandler?.DynamicMasterRowEdit ??
      ((
        actionType: SetStateAction<string>,
        record: { Key: SetStateAction<number> }, // NOSONAR : ignore
      ) => {
        setHideBtn(false);
        setType(actionType);
        setFormRId(record.Key);
        setMode("Edit");
      }), // NOSONAR : ignore
  };
  const childReportHandlers = {
    ...reportActionHandler,
    DynamicReportActionCreate:
      reportActionHandler?.DynamicReportActionCreate ??
      ((actionType: SetStateAction<string>, ...params: any[]) => {
        setHideBtn(false);
        setType(actionType);
        setFormRId(0);
        setMode("Create");

        ////Hetal Code
        // if (props?.InnerInterfaceName && props?.InnerDashboardName) {
        //   props?.LoadInnerInterface();
        // }

        return true;
      }),
  };

  const [subtitle, setSubTitle] = useState<string>("");
  const childinterfaceActionHandler = {
    ...interfaceActionHandler,
    // handleSubmit:
    //   // interfaceActionHandler?.handleSubmit ||
    //   async (actionType: string, ...params: any[]) => {
    //     console.log(`${actionType} action with parameters:`, params);
    //     //Simulate an async operation (e.g., an API call)
    //     await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
    //     // return `Successfully edited record with ID ${params[0]}`; // Return message
    //     return true;
    //   },
    // CreateJson: async (apiValues, fieldName, questionKeys = []) => {
    //   const inflated = { ...apiValues };
    //   console.log("93", apiValues);
    //   // Explicit mapping of keys from apiValues to desired keys
    //   const testMarks = 20;
    //   // const obtainedMarks = apiValues.TotalScore ?? apiValues.obtainedMarks;
    //   const result = apiValues.Remarks ?? apiValues.result;
    //   const responses = { q1: 2, q2: 3, q3: 4, q4: 5 };
    //   // questionKeys.forEach((qKey, index) => {
    //   //   const val = apiValues[qKey];
    //   //   if (val !== undefined) {
    //   //     responses[`q${index + 1}`] = Number(val);
    //   //   }
    //   // });
    //   inflated[fieldName] = {
    //     testMarks,
    //     responses,
    //     // obtainedMarks,
    //     result,
    //   };
    //   return inflated;
    // },
    SetSubTitle: (status: any) => {
      setSubTitle(`${status}`);
    },
  };
  //  console.log('hideBtn', hideBtn , ' props hideTitle', props);
  return (
    <ActionHandlerProvider
      rowActionHandler={childRowHandlers}
      reportActionHandler={childReportHandlers}
      interfaceActionHandler={childinterfaceActionHandler}
      interfaceFieldActionHandler={interfaceFieldActionHandler}
      autoSearchActionHandler={autoSearchActionHandler}
    >
      {hideBtn ? (
        <DynamicReport
          InterfaceName={props?.InterfaceName}
          DashboardName={props?.DashboardName}
          ref={dashboardRef}
          hideTitle={props?.hideTitle}
        />
      ) : (
        <InterfaceComponent
          InterfaceName={props?.InterfaceName}
          DashboardName={props?.DashboardName}
          actionType={type}
          RId={formRId}
          Mode={mode}
          handleCancel={handleCancel}
          ref={formRef}
          hideTitle={props?.hideTitle}
          subTitle={subtitle}
        />
      )}
    </ActionHandlerProvider>
  );
});

export default DynamicMaster;
